import React, { Component } from "react"
import { Mutation } from "react-apollo"
import UPDATE_PASSWORD_LOGGED_IN from "../../graphql/updatePasswordLoggedIn.graphql"
import "./editPasswordModal.scss"

class EditPasswordModal extends Component {
  state = {
    oldPassword: "",
    newPassword: "",
    passwordConfirm: "",
    minPasswordLength: 8,
    dialogue: null,
  }

  handlePasswords = (key, e) => {
    this.setState({
      [key]: e.target.value,
      dialogue: null,
    })
  }

  handleSave = (e) => {
    e.preventDefault()

    const {
      oldPassword,
      newPassword,
      passwordConfirm,
      minPasswordLength,
    } = this.state

    if (!oldPassword || !newPassword || !passwordConfirm) {
      return this.setState({
        dialogue: "Please fill out all forms.",
      })
    }

    if (newPassword.length < minPasswordLength) {
      return this.setState({
        dialogue: `Password must be at least ${minPasswordLength} characters long.`,
      })
    }

    if (newPassword !== passwordConfirm) {
      return this.setState({
        dialogue: "Your new password does not match.",
      })
    }

    this.props
      .updatePasswordLoggedIn({ variables: { oldPassword, newPassword } })
      .then((res) => {
        if (res.data.updatePasswordLoggedIn.payload === "oldPasswordInvalid") {
          return this.setState({
            dialogue: "Your old password was incorrect.",
          })
        } else if (
          res.data.updatePasswordLoggedIn.payload === "newPasswordSaved"
        ) {
          this.setState({
            oldPassword: "",
            newPassword: "",
            passwordConfirm: "",
            dialogue: null,
          })
          this.props.close()
        } else {
          return this.setState({
            dialogue: "Error Occurred: Your new password was not saved.",
          })
        }
      })
  }

  render() {
    return (
      <div className="edit-password-container">
        <div className="edit-password-header">
          <h1>Edit Password</h1>
        </div>

        <div className="edit-password-inputs-container">
          <div
            id="edit-password-old-password"
            className="edit-password-input-large"
          >
            <div className="edit-password-input-label">
              <span>Old Password:</span>
            </div>
            <input
              type="password"
              value={this.state.oldPassword}
              onChange={(e) => this.handlePasswords("oldPassword", e)}
            />
          </div>

          <div
            id="edit-password-new-password"
            className="edit-password-input-large"
          >
            <div className="edit-password-input-label">
              <span>New Password:</span>
            </div>
            <input
              type="password"
              value={this.state.newPassword}
              onChange={(e) => this.handlePasswords("newPassword", e)}
            />
          </div>

          <div
            id="edit-password-new-password-confirm"
            className="edit-password-input-large"
          >
            <div className="edit-password-input-label">
              <span>Confirm New Password:</span>
            </div>
            <input
              type="password"
              value={this.state.passwordConfirm}
              onChange={(e) => this.handlePasswords("passwordConfirm", e)}
            />
          </div>

          <div id="edit-password-dialogue">
            <h4>{this.state.dialogue}</h4>
          </div>
        </div>

        <div className="edit-password-buttons-container">
          <button id="edit-password-save-button" onClick={this.handleSave}>
            Save
          </button>
          <button id="edit-password-cancel-button" onClick={this.props.close}>
            Cancel
          </button>
        </div>
      </div>
    )
  }
}

const EditPasswordModalWithData = (componentProps) => (
  <Mutation mutation={UPDATE_PASSWORD_LOGGED_IN}>
    {(mutate) => (
      <EditPasswordModal {...componentProps} updatePasswordLoggedIn={mutate} />
    )}
  </Mutation>
)

export default EditPasswordModalWithData
